import React,{useEffect, useState} from 'react'
import {TextField,Grid, Box,Button} from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { PartnerWithUsTwoSchema } from '../../Utils/Validations'
import PhoneInput from 'react-phone-input-2'
import AuthState from '../../Hooks/Authinctication.state'
const PartnerWithUsTwo = ({ handleBack, handleComplete, partnerWithUsData, setPartnerWithUsData }) => {
  const {CheckUser,message,formBusy} = AuthState()
  const [email,setEmail] = useState("")
  const [phone,setPhone] = useState("")
  const [error,setError] = useState("")
  const { handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(PartnerWithUsTwoSchema)
  })
 
  useEffect(() => {
    setValue("email", partnerWithUsData.email || "")
    setValue("phone", partnerWithUsData.phone || "")
  }, [])
  const onSubmit = async (data) => {
    console.log(data)
    
    await CheckUser({email:data.email})
   
   
  }

useEffect(()=>{
  if(message?.type==="error"){
    setError(message.message)
  }else if(errors?.email){
    setError(errors.email.message)
  }else{
    setError("")
  }
  if(message.type==="success"){
    setPartnerWithUsData((prev) => ({ ...prev, email: email, phone: `+${phone}` }))
    handleComplete()
  }
},[message,errors])

  return (
    <div>
        
        <Grid container  style={{justifyContent:"center",marginTop:20}} >
            <Grid sm={6} xs={12} sx={{textAlign:"left",paddingRight:{sm:1,xs:0}}} >
            <Controller
            control={control}
            name="email"
            rules={{ required: true }}
            render={({ field:{onChange,value,onBlur} }) => (
              <>
                <label>Email Address</label>
                <TextField fullWidth placeholder='Email Address' value={value}  onBlur={onBlur}  onChange={(e)=>{onChange(e);setEmail(e.target.value)}} error={error} helperText={error} />
              </>
            )}
          />
               
       
        
        </Grid>
        <Grid sm={6} xs={12} sx={{textAlign:"left",paddingLeft:{sm:1,xs:0},marginTop:{sm:0,xs:2}}}>
        <Controller
            control={control}
            name="phone"
            rules={{ required: true }}
            render={({ field:{value,onChange} }) => (
              <>
                <label>Phone Number</label>
                <PhoneInput disableCountryCode onlyCountries={["us"]} country={"us"} placeholder='Enter your 10 digit phone number' value={value} onChange={(p)=>{onChange(p);setPhone(p)}} />
              { errors.phone? <p className='error-message' > {errors?.phone?.message}</p>:null}

              </>
            )}
          />
        
      
        </Grid>
        </Grid>
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          { formBusy?"Please wait...": "Next"}
        </Button>

      </Box>
    </div>
  )
}

export default PartnerWithUsTwo